enum PostType {
  SOS = 'sos',
  STANDARD = 'standard',
}

export default PostType
